import { REDIRECT_URLS, env } from "./redirects";

const env_level = env;

export const SDK_INIT_OPTIONS = {
  configLocationHost: null,
  debug: true,
  env: 'production', // 'stage' or 'production'
  language: 'en',
  useBaseSdkLocation: true,
  version: '2',
  crossDomain: true,
  allowedOrigins: [REDIRECT_URLS[env_level], 'http://localhost:5173'],
  oauth: {
    clientId: 'backlotclub',
    scope: 'openid profile email',
    responseType: 'code',
    redirectUrl: REDIRECT_URLS[env_level] + '/auth-callback/',
    state: 'oauth-callback'
  }
};